import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import ProtectedRoute from './routes/ProtectedRoute';
import CheckInPage from './pages/admin/CheckInPage';

const CadastroExpositor = lazy(() => import('../src/pages/CadastroExpositor'));
const Home = lazy(() => import("./pages/Home"));
const LoginPage = lazy(() => import("./pages/admin/LoginPage"));
const MainAdminPage = lazy(() => import("./pages/admin/MainAdminPage"));
const Logout = lazy(() => import("./pages/admin/Logout"));
const RelatorioIngressosVendidos = lazy(() => import("./components/RelatorioIngressosVendidos"));
const EmpresasPage = lazy(() => import('./pages/admin/EmpresasPage'));
const TiposIngressosPage = lazy(() => import('./pages/admin/TiposIngressosPage'));
const IngressosPage = lazy(() => import('./pages/admin/IngressosPage'));
const PedidosFinanceiroPage = lazy(() => import('./pages/admin/PedidosFinanceiroPage'));
const VendasPorDiaPage = lazy(() => import('./pages/admin/VendasPorDiaPage'));
const MovimentoCaixaPage = lazy(() => import('./pages/admin/MovimentoCaixaPage'));
const RelatorioDiarioEventoPage = lazy(() => import('./pages/admin/RelatorioDiarioEventoPage'));
const RelatorioMovimentoCaixaPage = lazy(() => import('./pages/admin/RelatorioMovimentoCaixaPage'));
const IngressosEmitidosPage = lazy(() => import('./pages/admin/IngressosEmitidosPage'));
const TesteImpressorasPage = lazy(() => import('./pages/admin/TesteImpressorasPage'));
const PoliticaPrivacidade = lazy(() => import('./pages/PoliticaPrivacidade'));
const TermosDeServico = lazy(() => import('./pages/TermosDeServico'));
const StoreLayout = lazy(() => import('./layouts/StoreLayout'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Carregando...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/32expofica/*" element={<StoreLayout />} />


          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/logout" element={<Logout />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <MainAdminPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/IngressosVendidos"
            element={
              <ProtectedRoute>
                <RelatorioIngressosVendidos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/checkin"
            element={
              <ProtectedRoute>
                <CheckInPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/empresas"
            element={
              <ProtectedRoute>
                <EmpresasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/tipos-ingressos"
            element={
              <ProtectedRoute>
                <TiposIngressosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/ingressos"
            element={
              <ProtectedRoute>
                <IngressosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/testes-impressora"
            element={
              <ProtectedRoute>
                <TesteImpressorasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/financeiro/pedidos"
            element={
              <ProtectedRoute>
                <PedidosFinanceiroPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/financeiro/vendas-por-dia"
            element={
              <ProtectedRoute>
                <VendasPorDiaPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/financeiro/movimento-caixa"
            element={
              <ProtectedRoute>
                <MovimentoCaixaPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/financeiro/relatorio-diario-evento"
            element={
              <ProtectedRoute>
                <RelatorioDiarioEventoPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/relatorios/movimento-caixa"
            element={
              <ProtectedRoute>
                <RelatorioMovimentoCaixaPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/relatorios/ingressos-emitidos"
            element={
              <ProtectedRoute>
                <IngressosEmitidosPage />
              </ProtectedRoute>
            }
          />

          <Route path="/cadastro-expositor" element={<CadastroExpositor />} />

          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-de-servico" element={<TermosDeServico />} />

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
